<template>
  <BootstrapModal
    class="CreateOrder"
    :disableButton="true"
    :remove-padding="true"
    
    v-on="$listeners"
  >
    <template #title>
      Bestelling toevoegen
    </template>

    <SetupStepsSidebar
      :steps="steps"
      :modal="true"

      ref="discount-steps"
      @save-form="createOrder"
    >
      <template #icon-general-details>
        <svg width="20" height="20" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 5H10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 7.5H10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 10H10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </template>
      <template #icon-shipping-address>
        <svg width="20" height="17" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 3H12C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5V9H12.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 9H1V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H8C8.26522 1 8.51957 1.10536 8.70711 1.29289C8.89464 1.48043 9 1.73478 9 2V7.68" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.5 9H6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.5 11C9.39543 11 8.5 10.1046 8.5 9C8.5 7.89543 9.39543 7 10.5 7C11.6046 7 12.5 7.89543 12.5 9C12.5 10.1046 11.6046 11 10.5 11Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4 11C2.89543 11 2 10.1046 2 9C2 7.89543 2.89543 7 4 7C5.10457 7 6 7.89543 6 9C6 10.1046 5.10457 11 4 11Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </template>
      <template #icon-invoice-address>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
        </svg>
      </template>
      <template #icon-products>
        <svg width="20" height="20" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.02979 9V13.5C2.02979 13.6326 2.08246 13.7598 2.17623 13.8536C2.27 13.9473 2.39718 14 2.52979 14H12.5298C12.6624 14 12.7896 13.9473 12.8833 13.8536C12.9771 13.7598 13.0298 13.6326 13.0298 13.5V9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.52979 9V14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2.02979 10.5H8.52979" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1.02979 4.5L2.52979 1H12.5298L14.0298 4.5H1.02979Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.28 4.5V5.5C5.28 6.03043 5.06929 6.53914 4.69421 6.91421C4.31914 7.28929 3.81043 7.5 3.28 7.5H3C2.46957 7.5 1.96086 7.28929 1.58579 6.91421C1.21071 6.53914 1 6.03043 1 5.5V4.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.77979 4.5V5.5C9.77979 6.03043 9.56907 6.53914 9.194 6.91421C8.81893 7.28929 8.31022 7.5 7.77979 7.5H7.27979C6.74935 7.5 6.24064 7.28929 5.86557 6.91421C5.4905 6.53914 5.27979 6.03043 5.27979 5.5V4.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14.0298 4.5V5.5C14.0298 6.03043 13.8191 6.53914 13.444 6.91421C13.0689 7.28929 12.5602 7.5 12.0298 7.5H11.7798C11.2494 7.5 10.7406 7.28929 10.3656 6.91421C9.9905 6.53914 9.77979 6.03043 9.77979 5.5V4.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </template>

      <template v-slot="{active}">
        <GeneralDetails v-model="generalDetails" class="disable-ske"/>
        <AddressForm 
          v-model="shippingAddress"
          class="disable-ske"
          key="shipping"
        />
        <AddressForm
          v-model="invoiceAddress"
          class="disable-ske"
          :copy-button="true"
          key="invoice"

          @copy="copyAddress"
        />
        <div>
          <ProductFinder v-model="products"/>
        </div>
      </template>
    </SetupStepsSidebar>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"
import SetupStepsSidebar from "../../SetupStepsSidebar/SetupStepsSidebar.vue"

import GeneralDetails from "../../../components/OrderForms/GeneralDetails.vue"
import AddressForm from "../../../components/OrderForms/AddressForm.vue"
import ProductFinder from "../../../components/Product/ProductFinder/ProductFinder.vue"

export default {
  components: {
    GeneralDetails,
    BootstrapModal,
    AddressForm,
    SetupStepsSidebar,
    ProductFinder,
  },
  props: {
    callback: Function,
  },
  data() {
    return {
      generalDetails: {},
      shippingAddress: {},
      invoiceAddress: {},
      products: [],
      
      steps: [
        {
          name: "Bestel Details",
          id: "general-details",
        },
        {
          name: "Verzendingsadres",
          id: "shipping-address"
        },
        {
          name: "Factuuradres",
          id: "invoice-address"
        },
        {
          name: "Producten",
          id: "products",
        },
      ],
    }
  },
  methods: {
    copyAddress() {
      this.invoiceAddress = { ...this.shippingAddress }
    },
    
    async createOrder() {
      const general = this.generalDetails
      const shipping = this.shippingAddress
      const invoice = this.invoiceAddress
      const orders = this.computedProducts

      /* if (!orders.length) {
        this.$refs["discount-steps"].setErrorIndex(3)
        return this.$error("De korting vereist minimaal één product!")
      } */
      
      await this.$handlePromise(async () => {
        await this.axios.post("/api/orders", {
          orderDate: new Date(),
  
          site: general.siteName,
          orderNumber: general.orderNumber,
          language: general.language,
          // shipmentTrackAndTrace: general.shipmentTrackAndTrace,
  
          shippingAddress: shipping,
          invoiceAddress: invoice,
          orders: orders,
        })

        this.$success("Nieuwe bestelling toegevoegd!")
        if (this.callback) this.callback()

        this.$emit("close")
      })
    },
  },
  computed: {
    computedProducts() {
      return this.products.map(item => {
        const obj = {...item}
        delete obj.src
        delete obj.error
        
        return obj
      })
    },
  },
  watch: {
    computedProducts(val) {
      if (val.length) {
        this.$refs["discount-steps"].removeIndexError(3)
      }
    },
  },
}

</script>

<style scoped>

.CreateOrder {
  flex-basis: 1300px;
  min-height: 600px;
}

@media (min-width: 769px) {
  .CreateOrder {
    min-height: 800px;
  }
}

@media (max-width: 400px) {
  .CreateOrder {
    min-height: 400px;
  }
}

</style>
